/**
 * viz プロトコルの型（docs/spec/viz-protocol.md §3, §5）。
 */

/** `show` イベントの kind（viz-protocol.md §3）。 */
export type VizKind = 'value' | 'array' | 'stack' | 'queue' | 'dict' | 'set';

export const VIZ_KINDS: readonly VizKind[] = ['value', 'array', 'stack', 'queue', 'dict', 'set'];

/** ラベル 1 つ分の状態。カードの `frames[].state` と同じ表現（card-schema.md §3.8）。 */
export interface VizState {
  kind: VizKind;
  value: unknown;
  head?: number;
  marks?: Record<string, number>;
}

export interface VizShow {
  t: 'show';
  step: number;
  ticks: number;
  label: string;
  kind: VizKind;
  value: unknown;
  head?: number;
  marks?: Record<string, number>;
}

export interface VizNote {
  t: 'note';
  step: number;
  ticks: number;
  text: string;
}

export type VizEvent = VizShow | VizNote;

/** viz-protocol.md §5 の parseVizStderr の結果。 */
export interface VizTrace {
  /** step 昇順。 */
  events: VizEvent[];
  /** ticks 行が 1 つも無ければ null。final: false は下限。 */
  ticks: { total: number; final: boolean } | null;
  truncated: boolean;
  /** 読めなかった @@viz 行の数。 */
  malformed: number;
  /** @@viz 行を除いた stderr（UI と judge はこちらを使う）。 */
  userStderr: string;
}

/** viz-protocol.md §5.1 のフレーム。 */
export interface VizFrame {
  step: number;
  ticks: number;
  state: Record<string, VizState>;
  changed: string | null;
  note?: string;
}
